import React from "react";
import { Leaf, Flame, Award } from "lucide-react";
import { useReveal } from "../hooks/useReveal";
import { useLanguage } from "../context/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section id="about" className="relative py-24 bg-cream mandala-bg overflow-hidden">
      <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full border-2 border-[#D4A94A]/20 spin-slow pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-80 h-80 rounded-full border-2 border-[#7A1F1F]/10 spin-slow pointer-events-none" style={{ animationDirection: "reverse" }} />

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center relative">
        <div ref={r1.ref} className={`reveal ${r1.visible ? "in" : ""}`}>
          <p className="section-sub">{t.about.sub}</p>
          <h2 className="section-title text-4xl md:text-5xl mt-4 leading-tight">
            {t.about.title}
          </h2>
          <div className="ornament my-6 justify-start" style={{ justifyContent: "flex-start" }}>
            <span className="text-[#D4A94A] font-display tracking-widest text-xs">✦ ✦ ✦</span>
          </div>
          <p className="text-[#1B1512]/80 leading-relaxed text-base md:text-lg">
            {t.about.p1a}<span className="text-[#7A1F1F] font-semibold">PURI PURI</span>{t.about.p1b}
          </p>
          <p className="mt-4 text-[#1B1512]/80 leading-relaxed text-base md:text-lg">
            {t.about.p2}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {[
              { icon: Leaf, lines: t.about.f1 },
              { icon: Flame, lines: t.about.f2 },
              { icon: Award, lines: t.about.f3 },
            ].map((f, i) => (
              <div key={i} className="text-center group">
                <div className="w-14 h-14 mx-auto rounded-full bg-[#7A1F1F] border-2 border-[#D4A94A] flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                  <f.icon className="text-[#D4A94A]" size={22} />
                </div>
                <p className="mt-3 text-sm font-semibold text-[#7A1F1F]">{f.lines[0]}<br />{f.lines[1]}</p>
              </div>
            ))}
          </div>
        </div>

        <div ref={r2.ref} className={`reveal ${r2.visible ? "in" : ""} relative`}>
          <div className="grid grid-cols-2 gap-4">
            <div className="overflow-hidden rounded-lg shadow-xl group">
              <img src="/images/hq_entrance.jpg" alt="Eingang" className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-110" />
            </div>
            <div className="space-y-4 mt-8">
              <div className="overflow-hidden rounded-lg shadow-xl group">
                <img src="/images/hq_interior.jpg" alt="Innenraum" className="w-full h-36 object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
              <div className="overflow-hidden rounded-lg shadow-xl group">
                <img src="/images/hq_food2.jpg" alt="Indische Gerichte" className="w-full h-36 object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
            </div>
          </div>

          <div className="mt-6 max-w-md mx-auto">
            <div className="overflow-hidden rounded-lg shadow-xl group bg-[#1B1512]/5">
              <img
                src="/images/hq_family.jpg"
                alt="Familie Puri Puri"
                className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <p className="mt-4 text-center text-[#1B1512]/80 leading-relaxed text-base md:text-lg italic">
              {t.about.welcome}
            </p>
          </div>

          <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#D4A94A] rounded-lg -z-10" />
          <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-[#E86D1F] rounded-lg -z-10" />
        </div>
      </div>
    </section>
  );
}
